import { FileTextIcon, DownloadIcon, ActivityIcon, SmartphoneIcon } from 'lucide-react';

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/aNgPNPp9HFTusun7fi8uNL/Kit_digital_de_entrenamiento_triatlonablytyped.webp';

export const heroChips = [
  { icon: FileTextIcon, label: 'PDF digitale con contenuti visivi' },
  { icon: DownloadIcon, label: 'Download immediato' },
  { icon: ActivityIcon, label: 'Per diversi livelli di esperienza' },
  { icon: SmartphoneIcon, label: 'Android e iOS' },
];

export const disciplines = ['Nuoto', 'Ciclismo', 'Corsa', 'Alimentazione', 'Progressione', 'Strategia di gara'];
